import React from 'react';
import { type FieldValues } from 'react-hook-form';
import CreateEditDialogType from '@/constants/ui/CreateEditDialogType';
import translate from '@/lib/intl/translate';
import type { FormDialogContentProps } from './FormDialogContent';
import FormDialogContent from './FormDialogContent';

type CreateEditFormDialogContentProps<FormValues extends FieldValues> = Omit<
  FormDialogContentProps<FormValues>,
  'submitLabel'
> & {
  type: CreateEditDialogType;
};

export default function CreateEditFormDialogContent<
  FormValues extends FieldValues,
>({ type, ...rest }: CreateEditFormDialogContentProps<FormValues>) {
  const isCreate = type === CreateEditDialogType.CREATE;

  return (
    <FormDialogContent
      {...rest}
      submitLabel={translate(isCreate ? 'CREATE' : 'UPDATE')}
    />
  );
}
